import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineAdmin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M7.857 16.429H2.143c-.789 0-1.429-.64-1.429-1.429V2.143c0-.789.64-1.429 1.429-1.429h4.599c.655 0 1.227.446 1.386 1.082l.444 1.775h9.285c.79 0 1.429.64 1.429 1.43v3.57" />
      <path d="M10.714 12.5 15 10l4.286 2.5v4.286L15 19.286l-4.286-2.5z" />
      <path d="M14.286 14.643a.714.714 0 1 0 1.428 0 .714.714 0 0 0-1.428 0" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineAdmin;
